module.exports = __webpack_public_path__ + "static/media/mktools.c8b2a6e8.svg";